import AreaSelect from './AreaSelect';
import areaMixin from './mixin';

export { areaMixin };
export default AreaSelect;
